import React from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";

const SectionHeader = ({ icon, title, description }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        {icon && (
          <Box
            sx={{
              mr: 2,
              p: 1.5,
              borderRadius: "12px",
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            fontFamily: theme.typography.h1?.fontFamily,
            color: theme.palette.text.primary,
            fontSize: { xs: "1.5rem", sm: "1.75rem" },
          }}
        >
          {title}
        </Typography>
      </Box>
      {description && (
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            ml: icon ? 7 : 0,
            mb: 2,
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeader;
